.gd{border:1px solid #ddd;}